<div class="gtw-pagination-wrapper">
  <!-- Pagination controls -->
  <div class="pagination-page-size">
    <ap-pagination
      #paginationRef
      [min]="1"
      [max]="totalPages"
      [step]="1"
      [(ngModel)]="currentPage"
      (onChange)="onPageChange($event)"
      (keyup.enter)="onPaginationEnter($event)">
    </ap-pagination>

    <ap-dropdown 
      class="page-size-dropdown"
      [list]="pageSizeDropdownList" 
      [selectType]="'single'" 
      [title]="'Page size'"
      [inputAriaLabel]="'Page size'"
      [hideTitleOnInput]="true" 
      [(ngModel)]="selectedPageSizeItem" 
      (onSelect)="onPageSizeSelect($event)">
      @for (item of pageSizeDropdownList; track $index) {
<ap-dropdown-list-item 
        #dropdownListItem
        
        [item]="item"
        [ariaLabel]="setAriaLabel(item)">
      </ap-dropdown-list-item>
}
    </ap-dropdown>
  </div>

  <!-- Items info -->
  <span class="pagination-items-info">
    {{ itemsInfoText }}
  </span>
</div>
